
import Datepicker from 'vanillajs-datepicker/Datepicker';
import 'vanillajs-datepicker/css/datepicker-bs5.css';
import it from 'vanillajs-datepicker/locales/it';

window.Datepicker = Datepicker;
Object.assign(Datepicker.locales, it);